/**
 * SISTEMA DE DISEÑO UNIFICADO NUBELYTICS
 * Estándares TOP DE GAMA para toda la aplicación
 */

export const DESIGN_SYSTEM = {
  // TIPOGRAFÍAS COMPLETAMENTE UNIFICADAS
  typography: {
    // Títulos principales de página - ÚNICOS
    pageTitle: {
      fontSize: '1.75rem',
      fontWeight: 700,
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
      lineHeight: 1.2,
      letterSpacing: '-0.02em'
    },
    
    // Subtítulos de página - ÚNICOS
    pageSubtitle: {
      fontSize: '0.875rem',
      fontWeight: 400,
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
      lineHeight: 1.4,
      color: 'text.secondary'
    },
    
    // Títulos de cards/widgets - TODOS IGUALES
    cardTitle: {
      fontSize: '1rem',
      fontWeight: 600,
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
      lineHeight: 1.3
    },
    
    // Números grandes (métricas) - TODOS IGUALES
    metricNumber: {
      fontSize: '1.5rem',
      fontWeight: 700,
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
      lineHeight: 1.1,
      letterSpacing: '-0.01em'
    },
    
    // Labels de métricas - TODOS IGUALES
    metricLabel: {
      fontSize: '0.75rem',
      fontSize: '0.875rem',
      fontWeight: 500,
      color: 'text.secondary',
      textTransform: 'none',
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif'
    }
  },

  // ESPACIADO UNIFICADO
  spacing: {
    pageContainer: '2rem',
    cardPadding: '1.5rem',
    cardMargin: '1.5rem',
    sectionGap: '2rem',
    elementGap: '1rem'
  },

  // COLORES UNIFICADOS
  colors: {
    primary: '#1976d2',
    secondary: '#dc004e',
    success: '#2e7d32',
    warning: '#ed6c02',
    error: '#d32f2f',
    info: '#0288d1'
  },

  // CARDS UNIFICADOS
  card: {
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    padding: '1.5rem',
    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 1) 100%)',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
      transform: 'translateY(-2px)'
    }
  },

  // TÍTULOS DE PÁGINA ESTÁNDAR
  pageHeaders: {
    dashboard: {
      title: 'Mi Tienda',
      subtitle: 'Vista general de tu tienda'
    },
    products: {
      title: 'Análisis de Productos',
      subtitle: 'Rendimiento comercial y insights'
    },
    stats: {
      title: 'Métricas de Rendimiento',
      subtitle: 'Análisis avanzado de estadísticas'
    },
    customers: {
      title: 'Clientes',
      subtitle: 'Segmentación y análisis de clientes'
    },
    sales: {
      title: 'Ventas',
      subtitle: 'Análisis detallado de ventas'
    },
    carts: {
      title: 'Carritos',
      subtitle: 'Abandonos y recuperación'
    },
    predictions: {
      title: 'Predicciones',
      subtitle: 'Insights predictivos (Próximamente)'
    },
    competitive: {
      title: 'Competencia',
      subtitle: 'Análisis competitivo (Próximamente)'
    },
    reports: {
      title: 'Reportes',
      subtitle: 'Informes detallados exportables'
    },
    settings: {
      title: 'Configuración',
      subtitle: 'Ajustes de cuenta y facturación'
    }
  }
};

// Hook para usar el sistema de diseño
export const useDesignSystem = () => {
  return DESIGN_SYSTEM;
};
